import designationsData from "../../../data/UserProfileData/designations.json";
import designationGradesData from "../../../data/UserProfileData/designationGrades.json";

export const designations = designationsData.designations;
export const designationGrades = designationGradesData.designationGrades;


// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/UserProfile/ProfileData.js